document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-mobile-search-trigger]');
  if (!trigger) return;

  const headerDrawer = trigger.closest('header-drawer');
  const drawerSummary = headerDrawer?.querySelector(':scope > details > summary');
  const searchToggle = document.querySelector('.header__icons .header__search summary');

  if (!searchToggle) return;

  if (headerDrawer && drawerSummary) {
    headerDrawer.closeMenuDrawer(event, drawerSummary);
  }

  window.setTimeout(() => searchToggle.click(), 420);
});
